
import React from 'react'

function AnimatedImage(): React.JSX.Element {
  return (
    <img
      src="/lwrHomeNew.png"
      alt="Custom software development company for startups"
      className="h-full w-full"
    />
  )
}

export default AnimatedImage

